import { Button } from '@iheartjane/reefer';
import type { ReactNode } from 'react';

import styles from './choiceChip.module.css';

export interface ChoiceChipProps {
  disabled?: boolean;
  /** Optional leading icon */
  icon?: ReactNode;
  /** Pre-rendered label text. Caller owns casing and i18n. */
  label: string;
  onClick: () => void;
  selected: boolean;
  testId?: string;
}

/**
 * A self-toggling, multi-select choice chip, built on Reefer's tertiary Button
 * so colours come from the theme.
 *
 * TODO: replace with the shared Reefer Chip/Choice once it exists
 * Figma: https://www.figma.com/design/acoTASmDAGFqgCe4buL7CE/Reefer?node-id=26278-379&m=dev
 * Ticket: https://app.clickup.com/t/8407749/86bc0fkak
 */
export function ChoiceChip({
  disabled = false,
  icon,
  label,
  onClick,
  selected,
  testId,
}: ChoiceChipProps) {
  return (
    <Button
      alignment="left"
      aria-pressed={selected}
      className={styles['chip']}
      data-testid={testId}
      disabled={disabled}
      full
      label={label}
      onClick={onClick}
      startIcon={icon}
      variant={selected ? 'tertiary-selected' : 'tertiary'}
    />
  );
}
